import { render, staticRenderFns } from "./Leaderboards.vue?vue&type=template&id=0bfd6b38&scoped=true&lang=pug&"
import script from "./Leaderboards.vue?vue&type=script&lang=ts&"
export * from "./Leaderboards.vue?vue&type=script&lang=ts&"
import style0 from "./Leaderboards.vue?vue&type=style&index=0&id=0bfd6b38&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfd6b38",
  null
  
)

export default component.exports